import React, { useEffect, useState, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import i18next from 'i18next';
import Button from 'react-bootstrap-button-loader';
import styles from '../../../../styles/profile.module.css';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Slide from '@material-ui/core/Slide';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import AlertAlgo from '../../../controls/AlertSnack'
import AddIcon from '@material-ui/icons/Add';
import Fab from '@material-ui/core/Fab';
import AddressForm from './AddressForm';
import ProfilePendingList from '../ProfilePendingList';

import { getProfileList, getPendingProfileList } from '../../../../actions/myFile/profile';
import { toPhone, toPostalCode, isIOS } from '../../../../utils';

import { withNamespaces } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    rootProfile: {
        overflow: 'auto'
    },
    appBar: {
        position: 'fixed',
        backgroundColor: 'var(--color1) !important',
        color: 'var(--color2) !important'
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    divPending: {
        marginTop: '10px',
        padding: '10px',
        '& > div': {
            marginBottom: '10px'
        }
    },
    titlePending: {
        marginBottom: '10px'
    }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function PendingAddress(props) {
    const classes = useStyles();
    const [data, setData] = useState([]);
    const [open, setOpen] = useState(false);
    const [isReload, setIsReload] = useState(false);
    const [isPending, setIsPending] = useState(props.isPending);
    const [openWarning, setOpenWarning] = useState(false);
    const [isDataChanged, setIsDataChanged] = useState(false);

    const alertRef = useRef(null);
    const [isiOS, setIsiOS] = React.useState(isIOS());

    useEffect(() => {
        resize();
    }, []);

    useEffect(() => {
        if (isReload) {
            loadProfile();
            parentHandleReload();
        }
    }, [isReload]);

    useEffect(() => {
        loadProfile();
    }, [isPending]);

    const parentHandleReload = () => {
        props.handleReload();
    }

    const loadProfile = () => {
        if (isPending) {
            loadPendingProfileList();
        } else {
            loadProfileList();
        }
    }

    const loadProfileList = () => {
        getProfileList().then(response => {
            response.personalPhone = toPhone(response.personalPhone);
            response.personalCellphone = toPhone(response.personalCellphone);
            response.phoneOffice = toPhone(response.phoneOffice);
            response.corporateCellphone = toPhone(response.corporateCellphone);
            response.pager = toPhone(response.pager);
            response.postalCode = toPostalCode(response.postalCode);
            response.language = response.language === 'F' ? i18next.t('Language:french') : i18next.t('Language:english');

            setIsPending(response.isPending);

            setData(response);
        });
    }

    const loadPendingProfileList = () => {
        getPendingProfileList().then(response => {
            if (response.employeeChangeId == 0) {
                setIsPending(false);
                return;
            }
            response.personalPhone = toPhone(response.personalPhone);
            response.personalCellphone = toPhone(response.personalCellphone);
            response.postalCode = toPostalCode(response.postalCode);
            response.effectiveDate = new Date(response.effectiveDate);

            setData(response);
        });
    }

    const resize = () => {
        setTimeout(function () {
            const height = window.innerHeight;
            const titleBar = document.querySelector('#appBarTitle').clientHeight;
            const offSet = 50;

            const customHeight = height - titleBar - offSet;

            const element = document.querySelector('#divProfile');

            if (element !== undefined && element !== null) {
                element.style.height = `${customHeight}px`;
            }
        }, 0);
    }

    const handleEdit = () => {
        setOpen(true);
        setIsReload(false);
    }

    const handleCloseAdd = (reload, isSaved = false) => {
        if (isDataChanged == true && !isSaved) {
            setOpenWarning(true);
            return;
        }

        if (reload === true) {
            showMessageSuccess(i18next.t('profile:address.message.success'));
            setIsReload(reload);
        }
        setOpen(false);
    }

    const showMessageSuccess = (message) => {
        alertRef.current.showMessageSuccess(message);
    }

    const handleDataChanged = (isChanged) => {
        setIsDataChanged(isChanged);
    }

    const handleWarning = (isContinue) => {
        setOpenWarning(false);

        if (isContinue == true) {
            setOpen(false);
        }
    }

    const handleDelete = () => {
        showMessageSuccess(i18next.t('profile:address.message.delete'));
        setIsPending(false);
    }

    return (
        <React.Fragment>
            {!isPending && <div className={classes.divPending}>
                <div>
                    <span className={classes.titlePending}>{i18next.t('profile:address.noPendingTitle')}</span>
                </div>
            </div>}

            {isPending && <div>
                <ProfilePendingList isPending={isPending} isReload={isReload} handleEdit={handleEdit} handleDelete={handleDelete} />
            </div>}
            {!isPending && <Fab color="primary" aria-label="add" className={`addButtonFab ${isiOS && "addButtonFabIOS"}`} onClick={() => handleEdit()} >
                <AddIcon />
            </Fab>}

            <Dialog fullScreen open={open} onClose={handleCloseAdd} TransitionComponent={Transition}>
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <IconButton edge="start" color="inherit" onClick={handleCloseAdd} aria-label="close">
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="h6" className={classes.title}>
                            {i18next.t("profile:address.form.title")}
                        </Typography>
                    </Toolbar>
                </AppBar>
                <div className={styles.rootEditProfile}>
                    <AddressForm data={data} handleClose={handleCloseAdd} handleDataChanged={handleDataChanged} />
                </div>
            </Dialog>

            <Dialog
                open={openWarning}
                onClose={() => alert('false')}
                aria-labelledby="draggable-dialog-title"
            >
                <DialogTitle id="draggable-dialog-title">
                    {i18next.t('profile:message.warning')}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {i18next.t('profile:address.message.confirmExit')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={() => handleWarning(true)} color="primary" className={styles.buttonYesNo} variant="success">
                        {i18next.t('buttons:yes')}
                    </Button>
                    <Button onClick={() => handleWarning(false)} color="primary" className={styles.buttonYesNo} variant="success">
                        {i18next.t('buttons:no')}
                    </Button>
                </DialogActions>
            </Dialog>

            <AlertAlgo ref={alertRef} />
        </React.Fragment>
    );
}

export default withNamespaces(['profile', 'buttons'], { wait: true })(PendingAddress);